import { StepProps, useAutoNavigate } from '@betterment/js-runtime';
import { Box, H1, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../Shared/urlBuilder';
import { TransferSupport } from '../components/TransferSupport';

export const PlanSelectionStep: React.FC<StepProps> = ({ flowState }) => {
  const navigate = useAutoNavigate();

  return (
    <WorkflowLayout
      feature="advisor_network"
      pageTitle="Plan Selection"
      workflowTitle=""
      onClose={() => navigate(flowState.returnToPath)}
      size="large"
    >
      <Box css={{ display: 'grid', gap: 'space.300', placeItems: 'center' }}>
        <H1>Choose the level of advice that fits your needs</H1>

        <Text>
          Not sure which is right for you?{' '}
          <SambaAutoLink to={urlBuilder.appAdviceInitiationInterests.absolute()}>Schedule a call</SambaAutoLink> with
          our team to learn more about our advisors.
        </Text>
        <TransferSupport />
      </Box>
    </WorkflowLayout>
  );
};
